import React from 'react';

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 */

const createLocalContext = <A extends {} | null>() => {
  const ctx: React.Context<A> = React.createContext<A | undefined>(undefined);
  const useCtx = () => {
    const c: A = React.useContext(ctx);
    if (c === undefined) {
      throw new Error('useCtx must be inside a Provider with a value');
    }
    return c;
  };
  return [useCtx, ctx.Provider] as const; // 'as const' makes TypeScript infer a tuple
};

export default createLocalContext;
